import StorageManager from './storage/StorageManager';

const storage = new StorageManager();
const STORAGE_KEY = 'selectedCompanyId';

export const saveSelectedCompanyId = (companyId) => {
  if (companyId != null) {
    storage.setItem(STORAGE_KEY, companyId);
  } else {
    storage.removeItem(STORAGE_KEY);
  }
};

export const getSavedCompanyId = () => {
  const savedId = storage.getItem(STORAGE_KEY);
  if (savedId) {
    try {
      const parsedId = JSON.parse(savedId);
      return typeof parsedId === 'number' ? parsedId : null;
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const getCompanyFromSavedOrFirst = (companies) => {
  if (!companies || companies.length === 0) {
    return null;
  }

  const savedId = getSavedCompanyId();
  if (savedId != null) {
    const savedCompany = companies.find((company) => company.id === savedId);
    if (savedCompany) {
      return savedCompany;
    }
  }

  return companies[0];
};

export const getCompanyFromUrlOrSavedOrFirst = (companies, urlCompanyId) => {
  if (!companies || companies.length === 0) {
    return null;
  }

  if (urlCompanyId != null && !isNaN(Number(urlCompanyId))) {
    const urlCompany = companies.find(
      (company) => company.id === Number(urlCompanyId)
    );
    if (urlCompany) {
      return urlCompany;
    }
  }

  return getCompanyFromSavedOrFirst(companies);
};
